// Cart line quantity, sections/tu-cart.liquid.
//
// 2026-09-11, client: "the cart is not working properly, adding and removing
// products is buggy." The cause was in the markup, not here -- three controls
// per line all named `updates[<key>]`, so a submit posted two values for one
// line and Shopify kept whichever came last. `+` won that race, `-` lost it
// and did nothing. The input owns the name now; this file drives the steppers.
//
// Deliberately a plain form submit rather than the Cart AJAX API. A submit
// re-renders the whole page from the cart Shopify actually holds, so the line
// prices, the subtotal, the free-shipping line and the header count cannot
// drift apart from it -- and a full page load on a quantity press is a price
// worth paying on a cart, where being wrong is expensive and being slow is
// not. Without JavaScript the <noscript> Update button covers the same ground.
(function () {
  'use strict';

  function group(el) { return el.closest('[data-tu-qty-group]'); }

  function submitLine(input) {
    var form = input.form;
    if (!form) return;
    // Guard against a double submit from a fast second press: the page is
    // about to navigate, and a second POST would apply on top of the first.
    if (form.tuCartSubmitting) return;
    form.tuCartSubmitting = true;
    var g = group(input);
    if (g) g.classList.add('is-busy');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tu-qty-step]');
    if (!btn) return;
    var g = group(btn);
    var input = g && g.querySelector('[data-tu-qty-input]');
    if (!input) return;
    e.preventDefault();
    var step = parseInt(btn.getAttribute('data-tu-qty-step'), 10) || 0;
    var now = parseInt(input.value, 10);
    if (isNaN(now)) now = 0;
    var next = now + step;
    if (next < 0) next = 0;
    if (next === now) return;
    input.value = String(next);
    submitLine(input);
  });

  // Typing a number and leaving the field (or pressing Enter) commits it too,
  // so the box is never showing a quantity the cart does not hold.
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-tu-qty-input]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) { input.value = '0'; }
    submitLine(input);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-tu-qty-input]');
    if (!input) return;
    e.preventDefault();
    input.blur(); // fires `change` above when the value actually moved
    submitLine(input);
  });

  // Remove: same pattern as the live theme's cart-item remove
  // (Theme/live-20260822/snippets/cart-item.liquid + empire.js
  // _editItemQuantity/_updateCart) -- POST {id: key, quantity: 0} to
  // /cart/change.js by the line's own key, never the href's stale
  // line={{ forloop.index }} position (kept only as the <noscript>-era
  // no-JS fallback). Reload on success so the page still re-renders from
  // the cart Shopify actually holds, same as every other change here.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-tu-remove-line]');
    if (!link) return;
    e.preventDefault();
    if (link.tuRemoving) return;
    link.tuRemoving = true;
    var line = link.closest('.tu-line');
    if (line) line.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: link.getAttribute('data-key'), quantity: 0 }),
    })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.href = link.href; });
  });
}());
